import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle } from 'lucide-react';
const problems = [{
  title: 'Llegás al encuentro sin saber bien qué hacer',
  description: 'Sin herramientas claras para ese momento específico del proceso.'
}, {
  title: 'La persona no quiere cambiar y te desgastás',
  description: 'Sin una forma concreta de trabajar la motivación sin confrontar.'
}, {
  title: 'Cuando recae, no sabés cómo encararlo',
  description: 'El siguiente encuentro es el más difícil y el que más improvisás.'
}, {
  title: 'Le preguntás siempre lo mismo',
  description: 'Sin un banco de preguntas que realmente abran algo en la persona.'
}, {
  title: 'La familia te complica el proceso',
  description: 'No sabés cómo trabajar con el entorno sin que sabotee lo que construiste.'
}, {
  title: 'Buscás material y todo está en inglés o es demasiado clínico',
  description: 'Sin herramientas adaptadas al contexto argentino y al rol del orientador.'
}, {
  title: 'Cargás casos que te pesan y no sabés qué hacer con eso',
  description: 'Sin herramientas de autocuidado que sean reales y aplicables.'
}, {
  title: 'Fin de mes sin saber si lo que hacés funciona',
  description: 'Sin indicadores claros de avance para leer el proceso.'
}];
export function Problems() {
  return <section className="py-10 md:py-20 px-4" data-id="element-286">
      <div className="max-w-3xl mx-auto" data-id="element-287">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8 md:mb-12" data-id="element-288">
          <h2 className="font-serif text-2xl md:text-4xl font-bold text-navy-dark mb-3 md:mb-4" data-id="element-289">
            ¿Te pasa esto?
          </h2>
          <p className="text-base md:text-lg text-gray-700" data-id="element-290">
            Si acompañás personas con ludopatía en Argentina, esto te suena
            familiar:
          </p>
        </motion.div>

        <div className="space-y-2 md:space-y-3 mb-8 md:mb-12" data-id="element-291">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.04
        }} whileHover={{
          x: 4
        }} className="group bg-white px-4 md:px-5 py-3 md:py-4 rounded-lg shadow-sm border-l-2 border-red-400 hover:border-red-600 hover:shadow-md transition-all flex items-center gap-3 md:gap-4 cursor-default" data-id="element-292">
              <div className="flex-shrink-0 w-9 h-9 md:w-10 md:h-10 rounded-full bg-red-50 group-hover:bg-red-100 flex items-center justify-center transition-colors" data-id="element-293">
                <AlertTriangle className="w-4 h-4 md:w-5 md:h-5 text-red-600" data-id="element-294" />
              </div>
              <div className="flex-1 min-w-0" data-id="element-295">
                <h3 className="font-semibold text-navy-dark text-sm md:text-base leading-snug" data-id="element-296">
                  {problem.title}
                </h3>
                <p className="text-gray-600 text-xs md:text-sm mt-0.5 leading-snug" data-id="element-297">
                  {problem.description}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-center text-lg md:text-2xl font-bold text-navy-dark" data-id="element-298">
          ¿Cuántos encuentros más vas a improvisar?
        </motion.p>
      </div>
    </section>;
}